// SOCIAL MEDIA INSIDE PAGE
const socialMediaInsidePages = document.querySelectorAll(".inside-page__social-desingimg-grid-box");
socialMediaInsidePages.forEach((sol)=>{
    sol.addEventListener("click", function(e) {
        const id = e.target.dataset.img;
        // Get Click cordinate
        const ClientXValue = e.clientX;
        const ClientYValue = e.clientY;
        // Calculate Center of viewport
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;
        // Calculating the starting position relative to the center
        const startX = ClientXValue - centerX;
        const startY = ClientYValue - centerY;
        if (id) {
            const img = document.getElementById(id);
            const OverLayBox = document.querySelector(".inside-page__social-imageoverlay-box");
            const OverLayImage = document.querySelector(".inside-page__social-imageoverlay-image");
            const fullOverlayBg = document.querySelector(".inside-page-fullOverlay");
            fullOverlayBg.style.display = `block`;
            OverLayBox.classList.add("show");
            OverLayImage.src = img.src;
            document.documentElement.style.setProperty("--from-x", `${startX}px`);
            document.documentElement.style.setProperty("--from-y", `${startY}px`);
            document.documentElement.style.setProperty("--to-x", "-50%");
            document.documentElement.style.setProperty("--to-y", "-50%");
        } else console.log("No Image found");
    });
});
// OVERLAY CLOSE BTN
// const CloseBtn = document.querySelector(
//   ".inside-page__social-imageoverlay-box-close-btn"
// );
// CloseBtn.addEventListener("click", function (e) {
//   const OverLayBox = document.querySelector(
//     ".inside-page__social-imageoverlay-box"
//   );
//   const fullOverlayBg = document.querySelector(".inside-page-fullOverlay");
//   fullOverlayBg.style.display = `none`;
//   OverLayBox.classList.remove("show");
// });
/** INSIDE PAGE VIDEO */ document.addEventListener("DOMContentLoaded", function() {
    const videosPlayBtn = document.querySelectorAll(".inside-page__video-play");
    videosPlayBtn.forEach((playBtn)=>{
        const VideoContainer = playBtn.closest(".inside-page__video-hero");
        const video = VideoContainer.querySelector(".inside-page__video");
        // const PBtn = playBtn.children[0];
        const PBtn = playBtn.querySelector("img");
        console.log(PBtn.src);
        PBtn.setAttribute("src", "https://sk-new-web-img-video.s3.ap-south-1.amazonaws.com/play_icon.svg");
        const testImage = new Image();
        testImage.onload = ()=>console.log("Image Loaded");
        testImage.onerror = ()=>console.log("Image failed to load");
        testImage.src = "/img/play_icon.svg";
        playBtn.addEventListener("click", function(e) {
            if (video.paused || video.ended) {
                video.play();
                PBtn.src = "https://sk-new-web-img-video.s3.ap-south-1.amazonaws.com/pause_icon.svg";
                // playBtn.textContent = "Pause";
                this.style.display = "none"; // Hide when playing
            } else {
                video.pause();
                PBtn.src = "https://sk-new-web-img-video.s3.ap-south-1.amazonaws.com/play_icon.svg";
                // playBtn.textContent = "Play";
                this.style.display = "block"; // Show when paused
            }
        });
        //Show Play button when video ends
        video.addEventListener("ended", function() {
            PBtn.src = "https://sk-new-web-img-video.s3.ap-south-1.amazonaws.com/play_icon.svg";
            // playBtn.textContent = "Play";
            playBtn.style.display = "block";
        });
        video.addEventListener("play", function() {
            PBtn.src = "https://sk-new-web-img-video.s3.ap-south-1.amazonaws.com/pause_icon.svg";
            // playBtn.textContent = "Pause";
            playBtn.style.display = "none";
        });
        // Optional: Show button on hover when video is playing
        VideoContainer.addEventListener("mouseenter", function() {
            if (!video.paused && !video.ended) playBtn.style.display = "block";
        });
        VideoContainer.addEventListener("mouseleave", function() {
            if (!video.paused && !video.ended) playBtn.style.display = "none";
        });
        video.addEventListener("pause", function() {
            PBtn.src = "https://sk-new-web-img-video.s3.ap-south-1.amazonaws.com/play_icon.svg";
            // playBtn.textContent = "Play";
            playBtn.style.display = "block";
        });
    // video.addEventListener("timeupdate", function () {
    //   console.log(
    //     "⏱️ Time update:",
    //     video.currentTime,
    //     "/",
    //     video.duration,
    //     "Time Remain",
    //     video.duration - video.currentTime
    //   );
    // });
    });
});

//# sourceMappingURL=inside-social-takamaka.faef9de3.js.map
